export default class panelService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
	}

	get(){
		let url = this.baseUrl + '/api/tarjeta';
		return this.http.get(url);
	}

	refresh(){
		let url = this.baseUrl + '/api/tarjeta/refresh';
		return this.http.get(url);	
	}
}



// WEBPACK FOOTER //
// ./app/js/services/panelService.js